import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Emoji } from './Emoji';
type CountdownProps = {
  label: string;
  note?: string;
};
export function Countdown({
  label,
  note
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    suffix: 'hs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'seg'
  }];
  return <div className="text-center" data-id="element-59" data-mp="3c1mh8fg22fwl">
      <p className="inline-flex items-center justify-center gap-2 font-display text-sm font-bold uppercase tracking-[0.16em] text-gold" style={{
      fontSize: "18px"
    }} data-id="element-60" data-mp="3c0kxlmkz4l39">
        <Emoji symbol="⏰" data-id="element-61" data-mp="324rnsayn35p6" />
        {label}
      </p>
      <div className="mt-4 flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-62" data-mp="3262r69o6abfr">
        {units.map((unit, index) => <React.Fragment key={unit.suffix} data-id="element-63" data-mp="15awiglosu0og" data-mpi={index}>
            <div className="min-w-[84px] rounded-2xl border border-lime-400/20 bg-forest-800 px-3 py-3 sm:min-w-[104px] sm:px-5 sm:py-4" data-id="element-64" data-mp="y16il3eljtnj">
              <span className="block font-display text-3xl font-black tabular-nums text-lime-300 sm:text-5xl" data-id="element-65" data-mp="t12057u4oouo">
                {unit.value}
              </span>
              <span className="mt-1 block text-[11px] font-semibold uppercase tracking-widest text-cream/60" data-id="element-66" data-mp="12s53yhefzhxn">
                {unit.suffix}
              </span>
            </div>
            {index < units.length - 1 ? <span className="pt-3 font-display text-2xl text-lime-400/40 sm:pt-5 sm:text-3xl" data-id="element-67" data-mp="a40wprg82wsu">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
      {note ? <p className="mx-auto mt-5 max-w-md text-sm font-medium text-cream/75" data-id="element-68" data-mp="k0m3ah7w4fys">
          {note}
        </p> : null}
    </div>;
}